import Base from "@/api/Base";

export default class Get extends Base
{
	getMethod ()
	{
		return 'GET';
	}

	getUrl ()
	{
		return '/kandidat/sicherheit';
	}
}
